export function toDateKey(date: Date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function addDays(dateKey: string, amount: number) {
  const date = new Date(`${dateKey}T12:00:00`);
  date.setDate(date.getDate() + amount);
  return toDateKey(date);
}

export function formatDayLabel(dateKey: string) {
  const date = new Date(`${dateKey}T12:00:00`);
  const today = toDateKey(new Date());
  const formatted = new Intl.DateTimeFormat("pl-PL", { day: "numeric", month: "long" }).format(date);
  return dateKey === today ? `Dziś · ${formatted}` : formatted;
}

export function formatDateHeading(iso: string) {
  return new Intl.DateTimeFormat("pl-PL", { weekday: "long", day: "numeric", month: "long" }).format(new Date(iso));
}

export function formatTime(iso: string) {
  return new Intl.DateTimeFormat("pl-PL", { hour: "2-digit", minute: "2-digit", hour12: false }).format(new Date(iso));
}

export function formatTimeRange(startsAt: string, endsAt: string) {
  return `${formatTime(startsAt)}–${formatTime(endsAt)}`;
}

export function formatReminderDate(iso: string) {
  return new Intl.DateTimeFormat("pl-PL", { weekday: "long", day: "numeric", month: "long" }).format(new Date(iso));
}

export function combineDateAndTime(date: string, time: string) {
  return new Date(`${date}T${time}:00`);
}

export function dateKeyFromIso(iso: string) {
  return toDateKey(new Date(iso));
}

export function isTodayOrFuture(iso: string) {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  return new Date(iso).getTime() >= now.getTime();
}
